module.exports = __webpack_public_path__ + "img/scc-individual-temp.93d0c387.jpg";